import { pipe, prop } from 'ramda';
import { selectAllMeState } from 'src/common/state/me/me-selectors';

export const selectFlags = pipe(selectAllMeState, prop('flags'));

type BooleanFlag = 'expose-collections-menu-link';
type StringFlag = 'payment-collection-type';
type Flag = BooleanFlag | StringFlag;

export const selectFlag = (flag: Flag) =>
  pipe(selectFlags, (flags): string | boolean => {
    return flags[flag];
  });

export const selectBooleanFlag = (flag: BooleanFlag) =>
  pipe(selectFlag(flag), (flagValue) => !!flagValue);

export type PaymentCollectionType = 'card-element' | 'payment-element';
export const selectPaymentCollectionType = pipe(
  selectFlags,
  (flags): PaymentCollectionType =>
    (flags['payment-collection-type'] as PaymentCollectionType) ||
    'card-element'
);
